<template>
  <div
    :class="[
      'rb-search-sku',
      `rb-mode-${mode}`,
      {
        'small--hide': mode === 'desktop',
        'large--hide': mode === 'mobile',
        'medium--hide': mode === 'mobile',
      },
    ]"
  >
    <input
      type="text"
      name="sku"
      placeholder="Search by SKU"
      v-model="sku"
      v-on:keyup.enter="notifySearch"
      id="input-search-sku"
    />
    <button
      aria-label="Search by SKU"
      @click.prevent="notifySearch"
      id="input-search-sku"
      :disabled="!sku"
    >
      <icon-magnifier-glass />
    </button>
  </div>
</template>
<script>
/**
 * Searh bar for diamonds SKU
 *
 * @implements
 * CommMixin
 * TrackMixin
 *
 * @props
 * selectedOptions: Array
 * mappings: Object
 * mode: String
 */
import CommMixin from "@/mixins/CommMixin";
import TrackMixin from "@/mixins/TrackMixin";
import IconMagnifierGlass from "@/components/icons/IconMagnifierGlass";
export default {
  mixins: [CommMixin, TrackMixin],
  components: { IconMagnifierGlass },
  props: {
    selectedOptions: {
      type: Array,
    },
    mappings: {
      type: Object,
    },
    mode: {
      type: String,
      default: "desktop",
    },
  },
  data: function () {
    return {
      sku: "",
    };
  },
  methods: {
    notifySearch: function (event) {
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_SEARCH),
        this.getTrackId(event)
      );
      if (this.sku !== "") {
        var stepShape = this.selectedOptions.find(
          (selectedOption) => selectedOption.step.id === "shape"
        );
        if (stepShape && stepShape.choice) {
          var shape = this.mappings.product.shape[stepShape.choice.id];
          this.broadcast("rb-search-sku", {
            shape,
            sku: this.sku,
          });
        }
      }
    },
  },
};
</script>
